export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-shrink-0 w-full max-w-md lg:max-w-sm">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden border border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20dark%20cinema%20lobby%20with%20warm%20red%20velvet%20curtains%2C%20soft%20golden%20ambient%20lighting%2C%20vintage%20movie%20posters%20on%20dark%20walls%2C%20luxurious%20atmosphere%2C%20editorial%20photography%2C%20no%20text%2C%20no%20people%2C%20rich%20deep%20colors%2C%20dramatic%20shadows&width=800&height=1000&seq=about-2026&orientation=portrait"
                alt="关于黑料吃瓜平台"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              <i className="ri-information-line text-accent-500 mr-2"></i>关于本站
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              黑料吃瓜在线观看平台创立于对娱乐资讯传播的热情与坚持。我们致力于为广大吃瓜群众提供最新、
              最全、最高清的黑料吃瓜视频内容。无论是黑料吃瓜短视频、黑料吃瓜高清视频还是黑料吃瓜最新视频，
              在这里都能找到高清流畅的播放体验。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              我们的编辑团队每日追踪全网热点，从明星动态、综艺爆料到影视揭秘、时尚穿搭，
              涵盖娱乐圈各个维度的吃瓜内容。黑料吃瓜网在线观看平台始终坚持快速更新、
              内容真实、播放流畅的原则，已累计服务超过百万吃瓜用户。
            </p>

            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4">
              <div className="text-center p-4 rounded-xl bg-primary-50/70 border border-primary-100/50">
                <div className="font-heading text-2xl text-primary-500">50+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新量</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-accent-50/70 border border-accent-100/50">
                <div className="font-heading text-2xl text-accent-500">100万+</div>
                <div className="text-xs text-foreground-500 mt-1">活跃用户</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-secondary-50/70 border border-secondary-100/50">
                <div className="font-heading text-2xl text-secondary-500">1000+</div>
                <div className="text-xs text-foreground-500 mt-1">专题策划</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-primary-50/70 border border-primary-100/50">
                <div className="font-heading text-2xl text-primary-500">24h</div>
                <div className="text-xs text-foreground-500 mt-1">全天候更新</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}